// import hooks
import { redirect, useNavigate, Navigate } from "react-router-dom";
import useWindowSize from "../../utils/custom-hooks/useWindowSize";
// import components
import { Container } from "react-bootstrap";
import RoutPath from "../RoutPath";
import Avatar from "./Avatar";
import AccountList from "./AccountList";

// import assets
import "../../assets/css/account.css";
import avatar from "../../assets/img/user_pic.jpg";

// import data

const Account = () => {
    const windowWidth = useWindowSize();
    const navigate = useNavigate();
    if(windowWidth>=992){
        // alert("shit")
        // navigate("/user")
        return <Navigate to={"/user"} />
    }
    return (
        <section className="ocean-section account-section">
            <Container>
                <RoutPath />
                <Avatar avatar={avatar} name="احمد طه" points={120} />
                <AccountList />
            </Container>
        </section>
    );
};

export default Account;
